
import { useState } from "react";
import { formatPhoneNumber, validatePhoneNumber } from "@/utils/phoneValidation";

export const usePhoneInput = () => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const handlePhoneNumberChange = (value: string) => {
    setPhoneNumber(value);
  };

  const validatePhone = (): boolean => {
    if (!phoneNumber) {
      return false;
    }
    return validatePhoneNumber(phoneNumber);
  };

  const getFormattedPhone = (): string => {
    return formatPhoneNumber(phoneNumber);
  };

  return {
    phoneNumber,
    handlePhoneNumberChange,
    validatePhone,
    getFormattedPhone,
  };
};
